// No-data messages for grid
export const NO_RESULTS_MESSAGE =
  'No results this time. Try changing your filters or keywords to find what you need.';
export const NO_REQUIRED_DOCS_MESSAGE =
  'No Required Documents. There aren’t any documents needed for this submission, but you can still upload files if you’d like to include additional information.';
export const noDataMessageMapper = new Map<string, string>([
  ['studies', 'No studies are available for this account.'],
  ['sites', 'No sites are available for this account.'],
  ['organization-site-list', 'No sites linked to this organization.'],
  ['organization-study-list', 'No studies linked to this organization.'],
]);
